import UIComponent from '../../common/UIComponent';
import './index.css';
import { debounce, throttle, clearAllNode } from '../../common/Utils';
import log from 'loglevel';

/**
 * @description 时移进度条 - UI 控件
 */
export default class TimeshiftProgress extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.init();

    this.interfaces.on(VhallPlayer.LOADED, e => {
      this.progressContainer.setAttribute('class', 'vhallPlayer-progress-container display');
    });

    this.interfaces.on(VhallPlayer.TIMEUPDATE, e => {
      // TODO: 解决IOS上 IndexSizeError: The index is not in the allowed range.  报错
      if (this.interfaces.getBuffered().length <= 0) {
        return;
      }
      this.progressDuration = e.progressDuration;
      this.playedDuration = e.playedDuration;
      this.now = e.now;
      this.progressStartTime = e.progressStartTime;
      // 设置预加载条宽度
      const progressLoadValue =
        (this.interfaces.getBuffered().end(this.interfaces.getBuffered().length - 1) / this.progressDuration) * 100;
      this.progressLoad.style.width = progressLoadValue + '%';

      // seek状态时 不设置进度条的值
      if (this.isSeeking) {
        return;
      }
      // 设置播放进度条宽度
      const progressPlayValue = (this.playedDuration / this.progressDuration) * 100;
      if (progressPlayValue > 100) {
        return;
      }
      this.progressPlay.style.width = progressPlayValue + '%';
      this.scrubber.style.left = progressPlayValue + '%';
    });
  }

  init() {
    this.progressContainer = document.createElement('div');
    this.progressContainer.setAttribute('class', 'vhallPlayer-progress-container hide');
    this.progressContainer.onmousedown = this.handleMouseDown.bind(this);
    this.progressContainer.onmousemove = this.handleMousemove.bind(this);
    this.progressContainer.onmouseout = this.handleMouseout.bind(this);
    // this.progressContainer.onmousemove = debounce(this.handleMousemove.bind(this), 300);

    this.progressLoad = document.createElement('div');
    this.progressLoad.setAttribute('class', 'vhallPlayer-progress-load');

    this.progressPlay = document.createElement('div');
    this.progressPlay.setAttribute('class', 'vhallPlayer-progress-play');
    this.progressPlay.style.width = '100%';

    this.scrubber = document.createElement('div');
    this.scrubber.setAttribute('class', 'vhallPlayer-progress-scrubber');
    this.scrubber.style.left = '100%';
    // this.scrubber.innerHTML = `<i></i>`;

    var bar = document.createElement('i');
    this.scrubber.appendChild(bar);

    this.progressContainer.appendChild(this.progressLoad);
    this.progressContainer.appendChild(this.progressPlay);
    this.progressContainer.appendChild(this.scrubber);

    this.insertElement(this.elementId, this.progressContainer);
  }

  // 计算新的播放时间
  handleMouseDown(event) {
    // 按下鼠标时 则为正在seek
    this.isSeeking = true;
    // 鼠标按下时的位置
    const mouseX = event.clientX;
    let newLoc = event.offsetX;
    // 设置圆点位置
    this.scrubber.style.left = (newLoc / this.progressContainer.offsetWidth) * 100 + '%';
    // 设置播放进度条宽度
    this.progressPlay.style.width = (newLoc / this.progressContainer.offsetWidth) * 100 + '%';
    // 重置预加载条
    this.progressLoad.style.width = 0 + '%';
    // 记录鼠标按下时距左距离
    let left = event.offsetX;

    document.onmousemove = event => {
      // 计算移动差值 (鼠标所在位置 - 鼠标按下位置)
      const moveL = event.clientX - mouseX;
      // 计算新的播放位置
      newLoc = moveL + left;
      if (newLoc > this.progressContainer.offsetWidth) {
        newLoc = this.progressContainer.offsetWidth;
      }
      if (newLoc < 0) {
        newLoc = 0;
      }
      // 设置圆点位置
      this.scrubber.style.left = (newLoc / this.progressContainer.offsetWidth) * 100 + '%';
      // 设置播放进度条宽度
      this.progressPlay.style.width = (newLoc / this.progressContainer.offsetWidth) * 100 + '%';
    };

    document.onmouseup = e => {
      const progressDuration = Date.now() / 1000 - this.progressStartTime;
      const delay =
        ((this.progressContainer.offsetWidth - newLoc) / this.progressContainer.offsetWidth) * progressDuration;
      // 重置预加载条
      this.progressLoad.style.width = 0 + '%';
      // 设置圆点位置
      this.scrubber.style.left = (newLoc / this.progressContainer.offsetWidth) * 100 + '%';
      // 设置播放进度条宽度
      this.progressPlay.style.width = (newLoc / this.progressContainer.offsetWidth) * 100 + '%';
      // 关闭seek状态
      this.isSeeking = false;
      // 移除鼠标移动事件
      document.onmousemove = null;
      // 移除鼠标抬起事件
      document.onmouseup = null;
      const opts = {
        delay: delay
      };
      this.interfaces.handleTimeshiftPlay(opts, err => {
        log.error(`时移delay=${delay}`, err);
      });
    };
  }

  handleMousemove(e) {
    this.loc = e.offsetX;
    const bubbleEl = document.querySelector('.vhallPlayer-progress-bubble');
    bubbleEl.setAttribute('class', 'vhallPlayer-progress-bubble bubble-show');
    if (this.loc <= bubbleEl.offsetWidth / 2) {
      bubbleEl.style.left = '0%';
    } else if (this.loc >= this.progressContainer.offsetWidth - bubbleEl.offsetWidth / 2) {
      bubbleEl.style.left =
        ((this.progressContainer.offsetWidth - bubbleEl.offsetWidth) / this.progressContainer.offsetWidth) * 100 + '%';
    } else {
      bubbleEl.style.left = ((this.loc - bubbleEl.offsetWidth / 2) / this.progressContainer.offsetWidth) * 100 + '%';
    }
    const locTime =
      this.now / 1000 -
      ((this.progressContainer.offsetWidth - this.loc) / this.progressContainer.offsetWidth) * this.progressDuration;
    const showTime = isNaN(locTime) ? '00:00:00' : new Date(locTime * 1000).Format('yyyy-MM-dd hh:mm:ss').split(' ')[1];
    // bubbleEl.innerHTML = `<span style="color: white; margin-left: 2.2px">${showTime}</span>`;
    clearAllNode(bubbleEl);
    var bubspan = document.createElement('span');
    bubspan.setAttribute('style', 'color: white; margin-left: 2.2px');
    bubspan.textContent = showTime;
    bubbleEl.appendChild(bubspan);
  }

  handleMouseout() {
    const bubbleEl = document.querySelector('.vhallPlayer-progress-bubble');
    bubbleEl.setAttribute('class', 'vhallPlayer-progress-bubble bubble-hide');
  }
}
